import { render, staticRenderFns } from "./MemberFloatingChatComponent.vue?vue&type=template&id=9e8de818&scoped=true&"
import script from "./MemberFloatingChatComponent.vue?vue&type=script&lang=js&"
export * from "./MemberFloatingChatComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberFloatingChatComponent.vue?vue&type=style&index=0&id=9e8de818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8de818",
  null
  
)

export default component.exports